import script from "./dialogContent.vue?vue&type=script&setup=true&lang=js"
export * from "./dialogContent.vue?vue&type=script&setup=true&lang=js"

import "./dialogContent.vue?vue&type=style&index=0&id=6381ebbd&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1751107138/src/flip-child-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6381ebbd"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QList,QItemLabel,QItem,QItemSection});
